'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoServer = function GoServer(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 15h-25c-1.4 0-2.5 1.3-2.5 2.5v5c0 1.3 1.3 2.5 2.5 2.5h25c1.3 0 2.5-1.2 2.5-2.5v-5c0-1.2-1.2-2.5-2.5-2.5z m-22.5 7.5h-2.5v-5h2.5v5z m5 0h-2.5v-5h2.5v5z m5 0h-2.5v-5h2.5v5z m5 0h-2.5v-5h2.5v5z m7.5 5h-25c-1.4 0-2.5 1.3-2.5 2.5v5c0 1.3 1.3 2.5 2.5 2.5h25c1.3 0 2.5-1.2 2.5-2.5v-5c0-1.2-1.2-2.5-2.5-2.5z m-22.5 7.5h-2.5v-5h2.5v5z m5 0h-2.5v-5h2.5v5z m5 0h-2.5v-5h2.5v5z m5 0h-2.5v-5h2.5v5z m7.5-32.5h-25c-1.4 0-2.5 1.3-2.5 2.5v5c0 1.3 1.3 2.5 2.5 2.5h25c1.3 0 2.5-1.2 2.5-2.5v-5c0-1.2-1.2-2.5-2.5-2.5z m-22.5 7.5h-2.5v-5h2.5v5z m5 0h-2.5v-5h2.5v5z m5 0h-2.5v-5h2.5v5z m5 0h-2.5v-5h2.5v5z m7.5-2.5h-2.5v-2.5h2.5v2.5z' })
        )
    );
};

exports.default = GoServer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/server.js
// module id = 2256
// module chunks = 168707334958949